// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__xzkBs","cell":"ColumnAccessor_cell__1Sg6H","firstCellAccent":"ColumnAccessor_firstCellAccent__3YHIn"};